import React, { useContext, createContext, useState, useEffect } from 'react';
import { AuthContext } from "./authcontext";


export const ShopContext = createContext();


export  const ShopProvider = ({ children, initialShopData, pgid }) => {
    const [shopData, setShopData] = useState(initialShopData || null);
    //const [user, setUser] = useState(null);
    const { user, loggedIn } = useContext(AuthContext);
    const {userData} = useContext(AuthContext); // Get login state
    //const { loggedIn, setLoggedIn } = useContext(AuthContext);
    const [additionalInfo, setAdditionalInfo] = useState(null);
    
    const [loading, setLoading] = useState(true);
    //const [setLoggedIn] = useState(false);
    //const pgid = getPgidFromSubdomain();

    //console.log("ShopProvider: Fetching shop data for PGID:", pgid);

    useEffect(() => {
        if (!loggedIn || !user) return;
     
        const { aml, pgid, session_id } = user;
    
        if (!aml || !pgid || !session_id) {
            console.warn("⏳ Zusatzinfo not fetched: missing aml/pgid/session_id", user);
            return;
        }
    
        //console.log("🔄 Fetching Zusatzinfo in ShopProvider:", aml, pgid, session_id);
    
        fetch(`/api-zusatzinfo/${aml}/${pgid}/${session_id}`)
            .then(async res => {

            // 1) Get the raw bytes
            const arrayBuffer = await res.arrayBuffer();
      
            // 2) Decode manually as Windows-1252
            const decoder = new TextDecoder("windows-1252");
            const decodedText = decoder.decode(arrayBuffer);
      
            // 3) Parse JSON
            const data = JSON.parse(decodedText);
      
            // 4) Store it
            setAdditionalInfo(data);
        })
        .catch(err => console.error("Failed to load Zusatzinfo", err));
      
    }, [loggedIn, user]);


    useEffect(() => {
        if (!pgid) return;

        //  Only fetch if data is not already loaded
        if (!shopData) {
            //console.log("🔄 Fetching shop data in ShopProvider for PGID:", pgid);
            fetch(`/api-shopinfo/${pgid}`)
                .then((res) => res.json())
                .then((data) => {
                    //console.log(" Shop data received in ShopProvider:", data);
                    setShopData(data.success && data.records?.length ? data.records[0] : null);
                })
                .catch((err) => console.error("❌ Error fetching shop data:", err));
        }
    }, [pgid]);


    useEffect(() => {
        if (!loggedIn || !user) return;
    
        const { aml, pgid, session_id } = user;
    
        if (!aml || !pgid || !session_id) return;
    
        fetch(`/api-zusatzinfo/${aml}/${pgid}/${session_id}`)
            .then(async res => {

            // 1) Get the raw bytes
            const arrayBuffer = await res.arrayBuffer();
      
            // 2) Decode manually as Windows-1252
            const decoder = new TextDecoder("windows-1252");
            const decodedText = decoder.decode(arrayBuffer);
      
            // 3) Parse JSON
            const data = JSON.parse(decodedText);
      
            // 4) Store it
            setAdditionalInfo(data);
        })
        .catch(err => console.error("Failed to load Zusatzinfo", err));
      
    }, [loggedIn, user]);

      console.count("ShopProvider renders");


    useEffect(() => {
        //console.log("🛒 Updated shopData in context:", shopData);
    }, [shopData]);




    return (
        <ShopContext.Provider value={{ shopData, setShopData, additionalInfo, pgid, user,  loggedIn, loading }}>
            {children}
        </ShopContext.Provider>
    );
};



export const useShop = () => {
    return useContext(ShopContext);
};



export default ShopProvider;

